module.exports = __webpack_public_path__ + "static/texture-fecb9be14f75d9138effcea49a5ec50d.png";